
<template>
  <div class="m">
    <div class="banner">
      <el-carousel :interval="5000" :height="bannerHeight+'px'" trigger="click" >
        <el-carousel-item v-for="(item,index) in bannerlist" :key="'ib'+ index">
          <img :src="BaseUrl +item.thumb" style="width: 100%;height: auto"/>
        </el-carousel-item>
      </el-carousel>
    </div>
<!--新闻-->
    <div class="inews mp">
      <div class="ym flex_lr_t">
        <div class="inews_l">
          <el-carousel trigger="click" height="356px">
            <el-carousel-item v-for="(item,idx) in newsList" :key="idx"
                              v-if="item.thumb && idx<=5">
              <div @click="toUrl('/news_detail/'+item.id)">
                <img :src="BaseUrl + item.thumb" />
                <h3 class="small overflow_1">{{ item.title }}</h3>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="inews_r">
          <div style="position: relative">
            <el-tabs >
              <el-tab-pane label="新闻中心">
                <ul class="new_ul">
                  <li v-for="(item,index) in newsList" v-if="index<7" :key="index">
                    <router-link :to="'/news_detail/' + item.id" class="flex_lr">
                      <p class="overflow_1">{{ item.title }}</p>
                      <span>[{{item.create_time.substr(0,10) }}]</span>
                    </router-link>
                  </li>
                </ul>
              </el-tab-pane>
            </el-tabs>
            <router-link class="el-tabs-more" :to="{ path: '/news', query: {} }">更多 MORE +</router-link>
          </div>

        </div>
      </div>

      <ul class="ym inewsb flex_lr">
        <li @click="ntoUrl('/company/1',1)"><img src="../assets/index/inews1.png" /></li>
        <li @click="ntoUrl('/company/2',2)"><img src="../assets/index/inews2.png" /></li>
        <li @click="ntoUrl('/company/3',3)"><img src="../assets/index/inews3.png" /></li>
        <li @click="ntoUrl('/company/4',4)"><img src="../assets/index/inews4.png" /></li>
      </ul>
    </div>

<!--关于博雅-->
    <div class="iabout">
      <div class="ititle">
        <h5><span>关于</span><span>博雅</span></h5>
        <p><span>ABOUT</span>&nbsp;&nbsp;<span>BOYA</span></p>
      </div>

      <div class="ym iabout_m">
        <div>
          <div v-show="iplays" class="flex_c" ><img @click="videoImg()" src="../assets/index/about_off.png"></div>
          <video ref="videoPlay" controls style="margin-bottom:4px">
            <source src="../assets/dz.mp4" type="video/mp4">
          </video>
        </div>
        <p>博雅文化产业集团 成立于1998年，自成立至今始终秉承“承担、自信、激情”的初心和企业理念，逐步发展成为集印刷出版、智慧科技应用、文化创意为核心的多元化产业集团，业务涉及印刷出版、数字化应用、展览展示、智慧党建、文化创意、艺术品复制与开发等。</p>
        <p>同时，根据集团发展及业务需要，在河南省科创走廊建立文化产业基地、数字信息基地、创新创业解化基地，建筑面积达20余万平方。</p>
        <p>河南博雅文化产业集团有限公司为弘扬和传承中原文化，积极承担建设中原文化艺术数据库，并与意大利米兰中国文化中心、日本日中文化交流中心、俄罗斯孔子学院等建立战略合作并落地博雅，同时与美国、英国、日本、新西兰、奥地利、俄罗斯、新加坡等国家文化、科技机构形成长效合作。</p>
        <p>河南博雅文化产业集团有限公司先后荣获高新技术企业、国家涉密数字化企业、河南省著名商标、河南省科技型中小企业、改革开放40年河南领军文化企业、郑州市文化产业示范幕地、郑州市先进基层党组织等荣誉称号。</p>
        <p>集团以文化创意为先导，以刚产业实体为依托，以科技产业技术做保障，实现数字化、智能化、网络化三化融合发展。为推动科技进步、文化繁荣贡献力量。</p>
      </div>
    </div>

<!--    业务范畴-->
    <div class="iservice">
      <div class="ititle">
        <h5><span>业务</span><span>范畴</span></h5>
        <p><span>BUSINESS</span>&nbsp;&nbsp;<span>CATEGORY</span></p>
      </div>

      <div class="iservice_m ym">
        <ul class="flex_lr">
          <li  @click="toUrl('/creativePlant')"><img src="../assets/index/iserve1.png"></li>
          <li @click="toUrl('/exhibitPlant')"><img src="../assets/index/iserve2.png"></li>
          <li @click="toUrl('/sciencePlant')"><img src="../assets/index/iserve3.png"></li>
          <li @click="toUrl('/printingPlant')"><img src="../assets/index/iserve4.png"></li>
          <li @click="toUrl('/artPlant')"><img src="../assets/index/iserve5.png"></li>
        </ul>
      </div>
    </div>

    <!--    博雅作品-->
<!--      background: url("../assets/index/work_bg.png") no-repeat center;
          background-size: 100% cover;
  -->
    <div class="iwork">
      <div class="iwork_bg"
           :style="'background:url('+ iwork_bg +') no-repeat center; backdrop-filter: blur(10px);' +
            'background-size: 100% 100%;transition:all 0.4s;'">
        <div></div>
      </div>

      <div class="ititle">
        <h5><span>博雅作品</span><span></span></h5>
        <p><span>BOYA WORKS</span>&nbsp;&nbsp;<span></span></p>
      </div>

      <div class="iwork_m ym" >
        <el-carousel @change="carouselChange"
                     ref="iworkimg" :interval="4000" type="card" height="402px">
          <el-carousel-item v-for="(item,idx) in workList"  :key="idx" v-if="idx<6">
            <img :src="BaseUrl + item.thumb" />
            <div class="iwork_on">
              <h5 class="small overflow_1">{{ item.title }}</h5>
              <p class="overflow_1">{{ item.desc }}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="iworkimg_l flex_c" @click="iworkimg('prev')">
          <img src="../assets/index/btn_l.png">
        </div>
        <div class="iworkimg_r flex_c" @click="iworkimg('next')">
          <img src="../assets/index/btn_r.png">
        </div>
      </div>
    </div>

    <!--    责任与信任-->
    <div class="iduty">
      <div class="ym iduty_m">
          <el-carousel ref="idutyimg"  indicator-position="none" :interval="5000" >
            <el-carousel-item v-for="(item,idx) in dutyList" :key="idx">
                <div class="flex_lr_t" @click="toUrl('/duty_detail/'+item.id)">
                  <div class="iduty_l">
                    <img :src="BaseUrl + item.thumb" />
                  </div>
                  <div class="iduty_r">
                    <h5 class="overflow_2">{{ item.title }}</h5>
                    <h6 class="overflow_4">{{ item.desc }}</h6>
                    <!--   <p>{{item.content}}</p>-->
                  </div>
                </div>
            </el-carousel-item>
          </el-carousel>

          <div class="iduty_btn flex_lr">
            <span @click="idutyimg('prev')"></span>
            <span @click="idutyimg('next')"></span>
          </div>
      </div>
    </div>

  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'
import {mapActions, mapState} from "vuex";
export default {
  components: {
    // 注册组件
    swiper,
    swiperSlide,
  },
  data(){
    return{
      bannerHeight:0,
      bannerlist:[],
      newsList:[],//头部新闻
      workList:[],//博雅作品
      dutyList:[],//责任与信任

      iwork_bg:'',//博雅作品背景图

      data:{},

      top_banner:[],
      bottom_banner:[],
      cur:0,
      curr:0,

      //通知
      noticeList: [],
      selected: '',

      value: '',
      nav_list:[],
      animate:false,
      intNum: null,
      imgIndex:0,

      iplays:true,//关于我们video
    }
  },
  filters: {
    filtersText(val) { // 要判断一下,如果是空就返回空字符串,不然会报错
      if (val != null && val != '') {
        var reg = /[\u4e00-\u9fa5]/g
        var names = val.match(reg)
        val = names.join('')
        return val
      } else return ''
    }
  },
  computed:{
    ...mapState(['BaseUrl','homemenu'])
  },
  methods: {
    ...mapActions(['homeindex',]),

    carouselChange(key1,key2){
      this.iwork_bg = this.BaseUrl + this.workList[key1].background
      console.log(this.iwork_bg,'this.iwork_bg')
    },

    videoImg(){
      console.log(this.iplays,'this.iplays')
      this.$refs["videoPlay"].play();
      this.iplays=false;
    },

    idutyimg(type){
      //this.$refs.idutyimg.prev()
      this.$refs['idutyimg'][type]()
    },

    iworkimg(type){
        this.$refs['iworkimg'][type]()
    },

    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },

    ntoUrl(url,n){
      this.$router.push({
        path: url
      })
    },

    toUrl(turl) {
      this.$router.push({
        path: turl
      })
    },
  },
  mounted() {

    if(sessionStorage.getItem("config_menu")){
      this.menu = sessionStorage.getItem("config_menu")
    }

    // 首次加载时,初始化高度
    this.screenWidth = window.innerWidth
    this.bannerHeight = 720 / 1920 * this.screenWidth
    window.onresize = () => {
      this.screenWidth = window.innerWidth
      this.bannerHeight = 720 / 1920 * this.screenWidth
    }

    this.homeindex().then((d) => {
      this.bannerlist = d.data.banner.index
      this.newsList = d.data.news.center
      this.workList = d.data.work
      this.iwork_bg = this.BaseUrl + d.data.work[0].background
      this.dutyList = d.data.duty

    })

  },
  created() {
   // this.$nextTick(() => {
  //  })
  }
}
</script>

<style scoped lang="less">
.banner{
  min-height: 400px;
  /deep/.el-carousel__item{
    transition: all 1.5s;
  }
  /deep/.el-carousel__item.is-animating {
    transition: opacity 1.5s ease-in-out !important;
  }
  //首页banner
  /deep/.el-carousel__indicators--horizontal{
    bottom: 7.7%;
    left: auto;
    right: 20%;
    .el-carousel__indicator--horizontal {
      display: inline-block;
      width: 10px;
      height: 10px;
      background: #FEFEFE;
      box-shadow: 2px 2px 2px #666;
      padding: 0;
      margin: 0 8px;
      transition: all 0.4s;
      .el-carousel__button{
        display: none;
      }
    }
    .el-carousel__indicator--horizontal.is-active{
      width: 28px;
      background: #BB0611;
    }
  }
  .padding-img{
    width: 100%;
    height: 100%;
    padding-top: 37.5%;
    position: relative;
    img{
      position: absolute;
      width: 100%;
      height: 100%;
      left:0;
      top:0;
    }
  }
  .el-carousel{
    min-height: 400px;
    .el-carousel__item{
      min-height: 400px;
      img{
        min-height: 400px;
        object-fit: cover;
      }
    }
  }
}
.el-carousel__item{
  background-color: #F7F8F8;
}


.mp{
  padding: 50px 0;
}

.inews{
  /deep/.el-carousel__indicators{
    display: none;
  }
  .inews_l{
      width: 48.5%;
      height: 356px;
      .el-carousel__item div{
        width: 100%;
        height:100%;
      }
      img{
        width: 100%;
        height:100%;
        object-fit: cover;
      }
      h3{
          position: absolute;
          bottom: 0;
          z-index: 10;
          background: rgba(0,0,0,0.6);
          width: 100%;
          line-height: 48px;
          height: 48px;
          color: #fff;
          text-align: center;
          font-weight: normal;
          font-size: 16px;
          padding: 0 40px;
          box-sizing: border-box;
        }
  }
  .inews_r{
    width: 47%;
    /deep/.el-tabs__nav-scroll{
      height: 44px;
      background: #eee;
    }
    /deep/.el-tabs__item{
      height: 44px;
      width: 112px;
      color: #7A7B78;
      text-align: center;
      line-height: 44px;
      padding: 0;
    }

    /deep/.el-tabs__item.is-active{
      color: #fff;
    }
    /deep/.el-tabs__active-bar{
      height: 44px;
      width: 112px!important;
      background: url("../assets/index/inews_ac.png") no-repeat;
      background-size: 100% 100%;
      z-index: -1;
     // transition: transform .3s cubic-bezier(.645,.045,.355,1);
      transition: all 0s;
    }
    &>div{
      height: 356px;
    }
    .new_ul{
      padding-top: 10px;
      li{
        cursor: pointer;
        margin-bottom: 6px;
        position: relative;
        padding-left: 15px;
        p{
          width: 430px;
          line-height: 36px;
          font-size: 16px;
          color: #221815;
          cursor: pointer;
          transition: all 0.4s;
        }
        span{
            font-size: 14px;
            line-height: 36px;
            color: #898989;
            transition: all 0.4s;
          }
        &:after{
          content: '';
          position: absolute;
          left: 0;
          top: 15px;
          width: 5px;
          height: 5px;
          background: #666666;
          border-radius: 50%;
          transition: all 0.2s;
        }
        &:hover{
          p,span{
            color: #BB0611;
          }
          &:after{
            background: #BB0611;
          }
        }
      }
    }
  }
}

.inewsb{
  margin-top: 60px;
  padding: 0 35px;
  box-sizing: border-box;
  li{
    width: 210px;
    height: 116px;
    transition: all 0.4s;
    &:hover{
      margin-top: -30px;
    }
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.el-tabs-more {
  cursor: pointer;
  width: 120px;
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  text-align: right;
  color: #2F2725;
  display: block;
  position: absolute;
  text-align: center;
  top: 0;
  right: 0;
}

.ititle {
  text-align: center;
  margin-bottom: 40px;
  h5 {
    font-size: 36px;
    line-height: 48px;
    letter-spacing: 2px;
    position: relative;
    padding-bottom: 8px;
    margin-bottom: 10px;
    span {
      &:nth-child(1) {
        color: #333;
      }
      &:nth-child(2) {
        color: #AA1920;
      }
    }

    &:after {
      width: 50px;
      height: 4px;
      background: #AA1920;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, 0);
      content: '';
    }
  }

  p {
    font-size: 15px;
    font-weight: bold;
    line-height: 20px;
    position: relative;

    span {
      &:nth-child(1) {
        color: #333;
      }

      &:nth-child(2) {
        color: rgba(187, 0, 14, 0.8);
      }
    }
  }
}

.iabout{
  padding: 60px 0;
  background: url("../assets/index/about_bg.png") no-repeat;
  background-size: 100% 100%;
  //所有控件
  //video::-webkit-media-controls-enclosure{
  //  display: none;
  //}
  .iabout_m{
    &>div{
      float: left;
      margin: 5px 30px 20px 0;
      width: 580px;
      position: relative;
      &>div{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 444;
        background: url("../assets/join_img.png") no-repeat center;
        background-size: 100% 100%;
      }
      img{
        width: 100px;
        height: 100px;
        cursor: pointer;
      }
    }
    video{
      width: 580px;
    }
    p{
      text-indent: 32px;
      line-height: 28px;
      margin-bottom: 28px;
    }
  }
}

.iservice{
  padding: 40px 0;
  background: #eee;
  .iservice_m{
    ul{
      li{
        width: 19.8%;
        height: 472px;
        cursor: pointer;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          cursor: pointer;
          transition: all 0.4s;
        }
        &:hover{
          img{
            transform: scale(1.1);
          }
        }
      }
    }
  }
}

.iwork{
  padding: 50px 0;
  width: 100%;
  //background: url("../assets/index/work_bg.png") no-repeat center;
  //background-size: 100% cover;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  .iwork_bg{
    position: absolute;
    width: 110%;
    height: 110%;
    left: -5%;
    top: -5%;
    filter: blur(4px);
    div{
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.1);
    }
  }
  .ititle{
    h5,span{
      color: #fff!important;
    }
    h5:after{
      background: #fff;
    }
  }

  .iwork_m{
    /deep/.el-carousel__arrow{
      display: none;
    }
    .iworkimg_l, .iworkimg_r{
      position: absolute;
      top: 45%;
      transform: translateY(-50%);
      width: 50px;
      height: 50px;
      border-radius: 50%;
      z-index: 666;
      background: rgba(255,255,255,0.4);
      cursor: pointer;
      img{
        width: 28px;
        height: 28px;
        cursor: pointer;
      }
    }
    .iworkimg_l{
      left: -14%;
    }
    .iworkimg_r {
      right: -14%;
    }
    img{
      width: 100%;
      height:100%;
      object-fit: cover;
    }
    .iwork_on{
      position: absolute;
      bottom: 0;
      z-index: 10;
      background: rgba(0,0,0,0.6);
      width: 100%;
      padding: 10px 40px;
      box-sizing: border-box;
      color: #fff;
      text-align: center;
      visibility: hidden;
    }
    .el-carousel__item--card.is-active{
      .iwork_on{
        visibility: initial;
      }
    }
    h5{
      line-height: 38px;
      height: 38px;
      font-size: 22px;
      font-weight: normal;
    }
    p{
      line-height: 22px;
      height: 22px;
      font-size: 14px;
    }
  }
}

.iduty{
  padding: 80px 0;

  .iduty_btn{
    width: 132px;
    height: 52px;
    background: #BA1E29;
    box-sizing: border-box;
    position: absolute;
    left: 55%;
    bottom: 0;
    z-index: 777;
    span{
      width: 52px;
      height: 52px;
      cursor: pointer;
      transition: all 0.4s;
      &:nth-child(1){
        background: url("../assets/index/ibtn_l.png") no-repeat center center;
        background-size: 15px 25px;
      }
      &:nth-child(2){
        background: url("../assets/index/ibtn_r.png") no-repeat center center;
        background-size: 15px 25px;
      }
      &:hover{
        background-size: 18px 30px;
      }
    }
  }

  .iduty_m{
    padding: 0 50px;
    box-sizing: border-box;
    .el-carousel{
      min-height: 360px;
      .el-carousel__item{
        min-height: 360px;
        cursor: pointer;
      }
      .el-carousel__item.is-animating{
        transition: fadeIn 1.5s ease-in-out;
      }
    }
    /deep/.el-carousel__arrow{
      display: none!important;
    }
    .iduty_l{
      width: 47.8%;
      height: 360px;
      margin-right: 90px;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
      }
    }

    .iduty_r{
      width: 45%;
      h5{
        font-size: 36px;
        font-weight: bold;
        color: #221815;
        line-height: 40px;
        margin-bottom: 30px;
        cursor: pointer;
      }
      h6{
        font-size: 18px;
        font-weight: normal;
        color: #221815;
        line-height: 30px;
        margin-bottom: 18px;
        cursor: pointer;
      }
      p{
        font-size: 16px;
        font-weight: normal;
        color: #221815;
        line-height: 30px;
      }
    }
  }
}

//@keyframes fadeIn {
//  0% {
//    opacity: 0;
//  }
//  50% {
//    opacity: 1;
//  }
//  100% {
//    opacity: 0;
//  }
//}

.enTBss{
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  margin-top: -40px;
  .iphmiz{
    display: block;
    text-decoration: none;
    margin: 0px 1em;
    overflow: hidden;
    border-radius: 6px;
    opacity: 0.5;
    transition: transform 500ms ease 0s, opacity 500ms ease 0s;
    background: rgb(2, 182, 253);
    cursor: pointer;
    &.active{
      opacity: 1;
    }
    &>dl{
      display: flex;
      color: rgb(255, 255, 255);
      height: 300px;
      margin: 0px;
      dd{
        box-sizing: border-box;
        position: relative;
        width: 0px;
        height: 100%;
        overflow: hidden;
        margin: 0px;
        transition: width 500ms ease 0s;
        &>div{
          width: 400px;
          height: 100%;
          position: relative;
          p{
            position: absolute;
            bottom: 2em;
            left: 2em;
            line-height: 2;
            margin: 0px;
            white-space: pre;
            font-weight: bold;
            letter-spacing: 1px;
          }
        }
      }
      img{
        max-width: 256px;
        height: 256px;
        top: 22px;
        left: 22px;
        margin: auto;
        position: absolute;
        opacity: 0.16;
      }
    }
  }
}


</style>
